var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6016 30.9414 22.457 6.7695Q21.5273 5.375 20 5.375t-2.457 1.3945L3.3984 30.9414q-.7968 1.461 0 2.7891.7305 1.328 2.457 1.3945h28.2891q1.7266-.0664 2.4571-1.3945.7968-1.3281 0-2.7891M18.4062 14.4062q.1329-1.4609 1.5938-1.5937 1.461.1328 1.5938 1.5937v8.5q-.1329 1.461-1.5274 1.5938-.664 0-1.1289-.4648-.5313-.4648-.5313-1.129zM20 30.875q-.8633 0-1.4609-.5977t-.5977-1.4609q0-.9297.5977-1.5273T20 26.6914t1.4609.5977q.5977.5976.5977 1.5273 0 .8633-.5977 1.4609T20 30.875"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation-triangle.8c73147be41d00db2fbe8852dff2e13a.svg";